import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { RdSAPAssessmentReport } from '../data/rdsap-survey-details-data.service';


// Define the custom entity collection service
// This service is used to provide access to the RdSAPDetails data service
@Injectable({ providedIn: 'root' })
export class RdSAPSurveyDetailsService extends EntityCollectionServiceBase<RdSAPAssessmentReport> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('RdSAPDetails', serviceElementsFactory);
  }
}
